import { Box, Card, CardContent, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import CustomToolbar from "../../utils/customToolbar";

function DormantUserTable({dormantUser}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const columnDormant = [
        { field: "id", headerName: "No", width: 80 },
        { field: "fullName", headerName: "User Name", width: 200  },
        { field: "department", headerName: "Department", width: 180 },
        { field: "designation", headerName: "Designation", width: 180  },
        {
        field: "lastLogin", headerName: "Last Login ", width: 180 ,
            valueGetter: (params) => {
                if (params) {
                const formatted = dayjs(params).format('DD-MM-YYYY HH:mm');
                return formatted;
                }
            },
            renderCell: (params) => {
                return (
                <Box style={{ width: "100%", textAlign: "center" }}>
                {params.value || 'Never Logged In'}
                </Box>
                );
            }
    },
    ];
    
    return ( 
       <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ mt: 4, marginRight: 2, }}>
          <Card sx={{ flex:1 ,borderRadius: 3, boxShadow: 2, backgroundColor: "background.main", }}>
            <CardContent>
              {/* <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}> */}
                 {/* <Typography variant="h9" color="grey" gutterBottom marginRight={2}>
                    Statistics
                </Typography> */}
                {/* <Typography variant="h6" fontWeight="bold">
                    Dormant User List
                </Typography> */}
              {/* </Box> */}
             
              {dormantUser?.length ? (
                <div style={{ height: 390, width: "100%" }}>
                  <DataGrid
                    rows={dormantUser.map((item, index) => ({
                      id: index + 1,
                      fullName: item.fullName,
                      department: item.department,
                      designation: item.designation,
                      lastLogin: item.lastLogin,
                    }))}
                    slots={{ toolbar: CustomToolbar }}
                      initialState={{
                        density: "compact",
                      }}
                      slotProps={{
                      toolbar: {
                        title: "Dormant User List",
                        description: ``
                      },
                      loadingOverlay: {
                        variant: "linear-progress",
                        noRowsVariant: "skeleton",
                      },
                    }}
                    showToolbar
                    columns={columnDormant}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    disableRowSelectionOnClick
                    // sx={{
                    //   border: "none",
                    //   "& .MuiDataGrid-columnHeaders": {
                    //     backgroundColor: "rgba(0, 0, 0, 0.04)",
                    //     fontWeight: "bold",
                    //   },
                    // }}
                  />
                </div>
              ) : (
                <Typography variant="body" color="text.secondary">
                  Loading or no data...
                </Typography>
              )}
            </CardContent>
          </Card>
      </Stack>
     );
}

export default DormantUserTable;